import Banner from '@/components/UI/Banner';
import type { FC } from 'react';
import type { SendHeadline } from '@/components/Agents/SendValidator/utils/SendHeadline';

interface SendHeadlineBannerProps {
  headline: SendHeadline;
  testId: string;
  headlineTestId: string;
}

/**
 * A report section's headline, drawn in its tone. The tone and text are decided by the headline model, never
 * here; the tone is also the headline's `data-test-key`, so a test can say a section never reads as a pass.
 */
const SendHeadlineBanner: FC<SendHeadlineBannerProps> = ({ headline, testId, headlineTestId }) => (
  <Banner
    critical={headline.tone === 'critical'}
    warning={headline.tone === 'warning'}
    info={headline.tone === 'info'}
    success={headline.tone === 'success'}
    dismiss={false}
    testId={testId}
  >
    <p className="ma0 fw5" data-testid={headlineTestId} data-test-key={headline.tone}>
      {headline.text}
    </p>
  </Banner>
);

export default SendHeadlineBanner;
